import { DecodedValueMap, SetQuery } from 'use-query-params'

import { QueryParam } from '@percent/partner-dashboard/common/queryParams/queryParams.types'
import {
  DonationListStatusFilterEnum,
  DonationType
} from '@percent/partner-dashboard/services/donation/donationService.types'
import { TableColumnSortDirection } from '@percent/lemonade'

export type DonationTableQueryParams = {
  query?: QueryParam<string>
  status?: QueryParam<string[]>
  kinds?: QueryParam<string[]>
  category?: QueryParam<string[]>
  sort?: QueryParam<string>
  direction?: QueryParam<string>
}

export type DonationTableQueryParamsProps = {
  queryParams: DecodedValueMap<DonationTableQueryParams>
  setQueryParams: SetQuery<DonationTableQueryParams>
}

export const initialDirection: TableColumnSortDirection = 'DESC'

export const defaultStatus = [
  DonationListStatusFilterEnum.RequestedPayment,
  DonationListStatusFilterEnum.Active,
  DonationListStatusFilterEnum.Settled,
  DonationListStatusFilterEnum.ReceivedPayment,
  DonationListStatusFilterEnum.Disbursed
]

export const donationTypeTranslations = {
  [DonationType.Wallet]: 'typography.donationType.wallet',
  [DonationType.Matched]: 'typography.donationType.matched',
  [DonationType.Direct]: 'typography.donationType.direct',
  [DonationType.Hosted]: 'typography.donationType.onPlatform',
  [DonationType.External]: 'typography.donationType.offPlatform',
  [DonationType.Payroll]: 'typography.donationType.payroll'
} as const

export const donationCategoryTranslations = {
  grant: 'typography.donationCategory.grant',
  employee_impact: 'typography.donationCategory.employeeImpact',
  consumer_giving: 'typography.donationCategory.consumerGiving',
  corporate_donation: 'typography.donationCategory.corporateDonation',
  unclassified: 'typography.donationCategory.unclassified'
} as const
